import { useTranslation } from "react-i18next"
import { KpiRow } from "../delivery/atoms"

interface Props {
  slaRiskCount: number
  vipUrgentCount: number
  totalPending: number
  channelBreakdown: { local: number; supply: number; pickup: number }
  avgWaitHours: number
}

/** Хүлээлтэнд KPI row (canvas Ord_DeliveryHub): white tiles, status only as a dot (O22). */
export function PendingStatsCards({ slaRiskCount, vipUrgentCount, totalPending, channelBreakdown, avgWaitHours }: Props) {
  const { t } = useTranslation("delivery")
  const avgWait =
    avgWaitHours < 1
      ? t("manage.pending.minutes", { n: Math.round(avgWaitHours * 60) })
      : t("manage.pending.hours", { n: avgWaitHours.toFixed(1) })

  return (
    <KpiRow
      items={[
        {
          key: "sla",
          tone: slaRiskCount > 0 ? "red" : "grey",
          label: t("manage.pending.kpiSla"),
          value: slaRiskCount,
          meta: slaRiskCount > 0 ? t("manage.pending.kpiSlaMeta") : t("manage.pending.kpiSlaOk"),
        },
        {
          key: "urgent",
          tone: vipUrgentCount > 0 ? "amber" : "grey",
          label: t("manage.pending.kpiUrgent"),
          value: vipUrgentCount,
          meta: t("manage.pending.kpiUrgentMeta"),
        },
        {
          key: "total",
          tone: "grey",
          label: t("manage.pending.kpiTotal"),
          value: totalPending,
          meta: t("manage.pending.kpiTotalMeta", channelBreakdown),
        },
        {
          key: "wait",
          tone: "grey",
          label: t("manage.pending.kpiWait"),
          value: avgWait,
          meta: t("manage.pending.kpiWaitMeta"),
        },
      ]}
    />
  )
}
